import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserStore } from '../../../core/stores/user.store';
import { environment } from '../../../../environments/environment';
import { authEndpoints } from '../../../core/constants/auth-endpoints';

/**
 * Auth Guard for SSO-based authentication
 * Redirects to SSO login if user is not authenticated
 *
 * This guard is used on all protected routes. If the user is not authenticated,
 * they will be redirected to the central SSO server for authentication.
 * After successful authentication, the SSO server will redirect back to the
 * original URL the user was trying to access.
 */
export const authGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const userData = userStore.userData();

  if (userData) {
    return true;
  }

  // Redirect to SSO with return URL
  const currentUrl = window.location.href;
  const signinUrl = `${environment.ssoBaseUrl}${authEndpoints.SIGNIN_PATH}?next=${encodeURIComponent(currentUrl)}`;
  window.location.href = signinUrl;
  return false;
};

